export default {
  wownowLogin: false,
  appConfigCmstopicGetTopicPage: false,
  commodity: {
    status: false,
    list: [],
    isSetBossPosition: false
  },
  position: {},
  addNavRightButtonNum: 0,
  dataSourceCms: {
    data: {}
  },
  cmsData: undefined
};